export const toString = (obj) => {
    return Buffer.from(JSON.stringify(obj)).toString('base64')
}

export const fromString = (str) => {
    return JSON.parse(Buffer.from(str, 'base64').toString('utf-8'))
}
